<template>
    <div class="device-type-manange relative">
        <el-page-header @back="goBack" :content="page_title"></el-page-header>

        <div class="buttons" :style="{position: button_position}">
            <el-button @click="resetForm">重置</el-button>
            <el-button @click="search">筛选</el-button>
        </div>
        <div style="margin: 0 0 30px 0;">
            <span>{{ user_type }}：{{own_name}}</span>
        </div>

        <!-- 表单开始 -->
        <el-row class="inputs mg-20" :gutter="20">
            <el-col :md="6" :lg="6" :xl="4" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">好友姓名：</span>
                <el-input v-model="user_name" placeholder="姓名模糊搜索"/>
            </el-col>
<!--            <el-col :md="6" :lg="6" :xl="4">-->
<!--                <span class="fs-14 pd-r-10">用户类型：</span>-->
<!--                <el-select v-model="user_role" placeholder="请选择用户类型">-->
<!--                    <el-option-->
<!--                            v-for="item in allRole"-->
<!--                            :key="item.id"-->
<!--                            :label="item.name"-->
<!--                            :value="item.id"-->
<!--                    ></el-option>-->
<!--                </el-select>-->
<!--            </el-col>-->
        </el-row>
        <!-- 表单结束 -->

        <el-table ref="multipleTable"
                  :data="tableData"
                  border
                  style="width: 100%">
            <el-table-column prop="user_name" label="姓名" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="user_role" label="用户类型" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="message_count" label="聊天记录数" align="center"
                             label-class-name="label"></el-table-column>
            <el-table-column prop="last_msg_date" label="最新消息时间" align="center"
                             label-class-name="label"></el-table-column>
            <el-table-column
                    prop="address"
                    label="操作"
                    align="center"
                    label-class-name="label"
                    v-slot="scope"
            >
                <el-button :id="'doctorEdit'" @click="goEdit(scope.row)"
                           type="text" size="mini">聊天记录详情
                </el-button>
            </el-table-column>
        </el-table>
        <el-pagination
                class="mg-20 ta-r"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[10, 25, 50, 100]"
                :total="total"
                :page-size="perpage"
                :current-page="page"
                @current-change="changePage"
                @size-change="changeSite"
        ></el-pagination>
    </div>
</template>
<script>
    import {export2Excel} from "@/utils/excel";
    import env from "@/api/env";
    import {check} from "@/utils/checkData";
    import {getUserInfos} from "@/utils/userInfos";
    import {isMobile} from "@/api/order";

    export default {
        data() {
            return {
                page: 1,
                perpage: 10,
                total: 0,
                tableData: [],
                page_title: '聊天好友列表',
                user_type: '特属服务对象',
                allRole: [
                    {
                        id: 1,
                        name: '特属服务对象'
                    },
                    {
                        id: 3,
                        name: '特属专家'
                    },
                ],
                user_id: '',
                user_name: '',
                user_role: '',
                own_name: '',
                is_request: false,
                is_EventBus: false,
                button_position: 'absolute',
                is_mobile: false,
            };
        },
        created() {
            if (isMobile()) {
                this.button_position = 'static'
                this.is_mobile = true
            }
            let user_info = getUserInfos();
            if (user_info.role_id == 3) {
                this.page_title = '聊天好友列表(自己负责的部分)';
            }
            this.user_id = this.$route.params.user_id || localStorage.getItem('user_id');
            this.own_name = this.$route.params.own_name || localStorage.getItem('own_name');
            if (this.$route.params.user_role) {
                this.user_type = this.$route.params.user_role == 1 ? '特属服务对象' : '特属专家';
            } else {
                this.user_type = localStorage.getItem('user_type');
            }

            localStorage.setItem('user_id', this.user_id)
            localStorage.setItem('own_name', this.own_name)
            localStorage.setItem('user_type', this.user_type)
            // 获取用户列表
            this.getList();
        },
        mounted() {

        },
        methods: {
            // 获取所有医生
            getList() {
                let params = {
                    servername: 'Ruyi_chatAdminServices',
                    method: 'singleList',
                    pageinfo: {
                        page: this.page,
                        perpage: this.perpage,
                    },
                    params: {
                        user_id: this.user_id,
                        user_name: this.user_name,
                        user_role: this.user_role,
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    for (var i = 0; i < res.data.data.list.length; i++) {
                        switch (res.data.data.list[i].user_role) {
                            case '1':
                                res.data.data.list[i].user_role = '特属服务对象';
                                res.data.data.list[i].role_type_number = 1;
                                break;
                            case '3':
                                res.data.data.list[i].user_role = '特属专家';
                                res.data.data.list[i].role_type_number = 3;
                                break;
                        }
                    }
                    this.tableData = res.data.data.list;
                    this.total = res.data.data.page.count;
                });
            },

            // 改变每页条数
            changeSite(index) {
                this.perpage = index;
                this.getList();
            },

            //更换页码
            changePage(index) {
                this.page = index;
                this.getList();
            },

            // 重置按钮
            resetForm() {
                this.user_name = "";
                this.user_role = "";
                this.page = 1;
                this.getList();
            },

            // 搜索
            search() {
                this.page = 1;
                this.getList();
            },

            // 编辑
            goEdit(data) {
                this.$router.push({
                    name: "oneChatLogDetail", params: {
                        obj_id: data.objuserid,
                        user_id: data.user_id,
                        friend_name: data.remark_name,
                        own_name: this.own_name,
                    }
                });
            },

            // 返回上一页
            goBack() {
                this.$router.push({
                    name: "oneChatList",
                    params: {}
                });
            },
        }
    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";

    .docker_buttons {
        float: right;
        margin: 30px 0px 8px 0px;

        .el-button {
            width: 150px;
            height: 32px;
            line-height: 7px;
        }
    }
</style>
